import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["element"]
  }

  focus() {
    this.elementTarget.focus()
  }
}
